var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsAvatarPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "gsmy7f4yia",
    cx: 20,
    cy: 20,
    r: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-39 -294) translate(39 294)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "extjtu6okb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gsmy7f4yia"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#gsmy7f4yia"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M24.557 24.031l.89.713c.013 0 .624.488 1.249.779l1.235.58.027.014c.65.224 1.235.488 1.753.779 1.542.897 2.697 2.217 3.455 3.933.77 1.769 1.063 5.953 1.063 8.171H31.57c0-2.455-.345-5.98-.85-7.128-.518-1.201-1.289-2.086-2.351-2.693-.505-.29-1.13-.541-1.834-.752-.04-.013-.066-.013-.106-.027l-3.64 4.211-1.847-1.57v5.319h-2.657v-5.32l-1.847 1.571-3.64-4.21-.107.026c-.704.211-1.328.462-1.833.752-1.063.607-1.833 1.492-2.352 2.693-.504 1.148-.85 4.673-.85 7.128H5c0-2.218.292-6.402 1.063-8.17.757-1.717 1.913-3.037 3.454-3.934.518-.29 1.103-.555 1.754-.78l.026-.012 1.236-.581c.624-.29 1.236-.779 1.249-.779l.89-.713 4.942 4.607 4.943-4.607zm-.293 10.349c.735 0 1.329.591 1.329 1.32 0 .729-.594 1.32-1.329 1.32-.734 0-1.328-.591-1.328-1.32 0-.729.594-1.32 1.328-1.32zM21.328 6c2.936 0 5.342 2.323 5.58 5.28h3.335v2.64H14.964v2.191c0 3.155 2.086 5.729 4.65 5.729 2.564 0 4.65-2.574 4.65-5.729h2.657c0 4.62-3.281 8.369-7.307 8.369-4.025 0-7.307-3.749-7.307-8.369v-4.356C12.307 8.587 14.818 6 17.9 6zm0 2.64H17.9c-1.474 0-2.685 1.148-2.896 2.64h9.22c-.21-1.492-1.421-2.64-2.896-2.64z",
    mask: "url(#extjtu6okb)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAvatarPlaceholder);
export default __webpack_public_path__ + "static/media/icons-avatar-placeholder.183ba08f320c6c537278ec13cc67777b.svg";
export { ForwardRef as ReactComponent };